import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { PricingItem } from 'common/types';
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	List,
	ListItem,
	ListItemText,
	ListItemAvatar,
	Radio,
} from '@mui/material';

import EmptyState from 'common/components/EmptyState';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSelect: (tableName: string, items: PricingItem[]) => void;
}

const PricingTableSelectModal = (props: Props) => {
	const pricingTables = useSelector(ShopSelectors.activeShopPricingTables);
	const [selectedTable, setSelectedTable] = useState<string | undefined>();
	const { t } = useTranslation();

	const handleSelect = () => {
		if (!selectedTable || !pricingTables[selectedTable]) return;
		props.onSelect(selectedTable, pricingTables[selectedTable]);
		props.onClose();
	};

	return (
		<Dialog
			open={props.isOpen}
			onClose={props.onClose}
			aria-labelledby="pricingtable-select-dialog-title"
			fullWidth
			maxWidth="sm"
		>
			<DialogTitle id="pricingtable-select-dialog-title">{t('pricing.chooseTemplate')}</DialogTitle>
			<DialogContent style={{ maxHeight: '400px' }}>
				<EmptyState
					isEmpty={Object.keys(pricingTables).length === 0}
					isLoading={false}
					title={t('pricing.noSavedTemplates')}
					description=""
					render={() => (
						<List>
							{Object.keys(pricingTables).map((tableName) => (
								<ListItem
									key={tableName}
									divider
									button
									onClick={() => setSelectedTable(tableName)}
								>
									<ListItemAvatar>
										<Radio color="primary" checked={selectedTable === tableName} />
									</ListItemAvatar>
									<ListItemText primary={tableName} />
								</ListItem>
							))}
						</List>
					)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose}>{t('common:actions.cancel')}</Button>
				<Button
					color="primary"
					variant="contained"
					disabled={!selectedTable}
					onClick={handleSelect}
				>
					{t('common:actions.continue')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PricingTableSelectModal;
